module.exports = __webpack_public_path__ + "img/amusement_arcade.91f2f0c7.svg";